import * as React from 'react';
import DetalleVerBoton from './DetalleVerBoton';
import './LiquidacionDetalleTabla.css';
import './GestionLiquidaciones.css';

export default class LiquidacionesListItems extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            liquidaciones: props.liquidaciones,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.liquidaciones !== this.props.liquidaciones) {
            this.setState({ liquidaciones: this.props.liquidaciones });
        }
    }

    renderEstado = (liquidacion) => {
        const enPreparacion = liquidacion.idTipoEstadoLiquidacion === 2;
        return (
            <span
                className={`gestion-liquidaciones-estado-pill ${
                    enPreparacion
                        ? 'gestion-liquidaciones-estado-pill--preparacion'
                        : 'gestion-liquidaciones-estado-pill--liquidada'
                }`}
            >
                {enPreparacion ? 'En preparación' : 'Liquidada'}
            </span>
        );
    };

    render = () => {
        const { liquidaciones } = this.state;
        const total = liquidaciones.length;

        return (
            <div className="gestion-liquidaciones-resultados liquidacion-detalle-seccion">
                <div className="liquidacion-detalle-tabla-card">
                    <div className="liquidacion-detalle-tabla-card__header">
                        <h5 className="liquidacion-detalle-tabla-card__title mb-0">Resultados</h5>
                        <span className="liquidacion-detalle-tabla-card__badge">
                            {total} liquidación{total !== 1 ? 'es' : ''}
                        </span>
                    </div>
                    <div className="liquidacion-detalle-tabla-card__body">
                        <div className="table-responsive">
                            <table className="table table-hover liquidacion-detalle-tabla mb-0">
                                <thead>
                                    <tr>
                                        <th>N°</th>
                                        <th>Seller</th>
                                        <th>Fecha</th>
                                        <th>Órdenes</th>
                                        <th>Imp. Órdenes</th>
                                        <th>Comisiones</th>
                                        <th>Novedades</th>
                                        <th>Neto Liquidación</th>
                                        <th>Total a Facturar</th>
                                        <th>Estado</th>
                                        <th className="text-center">Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {liquidaciones.map((liquidacion, i) => (
                                        <tr
                                            key={liquidacion.idLiquidacion ?? i}
                                            className="hover-background-color"
                                        >
                                            <td><strong>{liquidacion.idLiquidacion}</strong></td>
                                            <td>{liquidacion.razonSocialSeller}</td>
                                            <td>{liquidacion.mostrarFecha}</td>
                                            <td>{liquidacion.cantidadOrdenes}</td>
                                            <td>${liquidacion.totalOrden}</td>
                                            <td>${liquidacion.comisionTotal}</td>
                                            <td>${liquidacion.totalNovedades}</td>
                                            <td>${liquidacion.totalLiquidacion}</td>
                                            <td>${liquidacion.totalFacturar}</td>
                                            <td>{this.renderEstado(liquidacion)}</td>
                                            <td className="text-center">
                                                <DetalleVerBoton
                                                    label="Abrir"
                                                    iconClass="fa-external-link"
                                                    title={
                                                        liquidacion.idTipoEstadoLiquidacion === 2
                                                            ? 'Editar liquidación'
                                                            : 'Ver liquidación'
                                                    }
                                                    onClick={() =>
                                                        this.props.onLiquidacionEditableFunction(
                                                            liquidacion.idSeller,
                                                            liquidacion.idLiquidacion
                                                        )
                                                    }
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}
